// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"c9250bbe","47":"959da227","497":"ac6e535a","832":"749a81e0","904":"3b3e9ff1","983":"ce6b7fd5"}[chunkId] + ".chunk.js";
};